import { axiosSFS, params } from '@/api/instance'

const fetchFlight = () => {
  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret + '/flight'
  return axiosSFS.get(url).then((response) => {
    let res = response?.data
    if (res?.success) {
      return res
    }
  })
}

const fetchFlightHistory = (param) => {
  const url = axiosSFS.defaults.baseURL + '/flights/history'
  return axiosSFS({
    method: 'post',
    url: url,
    data: {
      data: {
        fltref: param
      }
    }
  }).then(function (response) {
    let res = response?.data
    if (res?.success) {
      return res.data
    }
  })
}

const fetchFlightsSameRoute = () => {
  const url = axiosSFS.defaults.baseURL + '/passengers/' + params.secret
  return axiosSFS.get(url).then((response1) => {
    let res1 = response1?.data
    if (res1?.success) {
      const url2 = axiosSFS.defaults.baseURL + '/flights/same-route'
      return axiosSFS
        .post(url2, {
          data: {
            flight_id: res1.data.flight_id,
            dep: res1.data.dep,
            arr: res1.data.arr,
            flight_date: res1.data.flight_date,
            airline_id: res1.data.airline_id
          }
        })
        .then((response) => {
          let res = response?.data
          if (res?.success) {
            return res.data
          }
        })
    }
  })
}

export { fetchFlightHistory, fetchFlightsSameRoute, fetchFlight }
